import React, { ChangeEvent } from 'react';
import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface InputController {
  name?: string;
  label?: string;
  type?: string;
  isError?: boolean;
  errors?: string;
  defaultValue?: any;
  touched?: boolean;
  placeholder?: string;
  isfullWidth?: boolean;
  isboxShadow?: boolean;
  value?: any;
  endAdornment?: any;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onClick?: any;
  isSlim?: boolean;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  showAsterisk?: boolean;
  noMargin?: boolean;
  maxCharLength?: number;
}

export const useStyle = makeStyles(() => ({
  errorHelperText: { marginBottom: '16px !important' },
  inputStyle: {
    borderRadius: '24px !important',
    height: '49px  !important',
    marginBottom: '16px !important',
    boxShadow: '0px 0px 40px 0px rgba(0, 0, 0, 0.1) !important',
    outline: 'none !important',
    width: '100%',
  },
  inputStylehalf: {
    borderRadius: '24px !important',
    width: '340px  !important',
    height: '35px  !important',
    marginBottom: '16px !important',
    boxShadow: '0px 0px 40px 0px rgba(0, 0, 0, 0.1) !important',
    outline: 'none !important',
    backgroundColor: 'white',
  },
  inputStyleSlim: {
    borderRadius: '24px !important',
    height: '33px  !important',
    marginBottom: '16px !important',
    boxShadow: '0px 0px 40px 0px rgba(0, 0, 0, 0.1) !important',
    outline: 'none !important',
    width: '100%',
    backgroundColor: 'white',
  },
  boxShadowStyle: {
    boxShadow: 'none !important',
  },
  noMargin: {
    margin: '0!important',
  },
}));

export const InputField = ({
  name,
  label,
  isfullWidth = true,
  type = 'text',
  onChange,
  touched,
  isError = false,
  errors = '',
  defaultValue,
  onBlur,
  isboxShadow,
  placeholder,
  value,
  endAdornment,
  onClick,
  isSlim,
  multiline,
  rows,
  disabled,
  showAsterisk,
  noMargin,
  maxCharLength,
}: InputController) => {
  const classes = useStyle();

  return (
    <FormControl fullWidth error={false} defaultValue={defaultValue}>
      {!isSlim ? (
        <InputLabel htmlFor={label} sx={{ top: '-3px' }}>
          {label}
          {showAsterisk && <span style={{ color: 'red' }}>*</span>}
        </InputLabel>
      ) : (
        <></>
      )}
      <OutlinedInput
        className={`${isfullWidth ? classes.inputStyle : classes.inputStylehalf}
                  ${isboxShadow ? classes.boxShadowStyle : classes.inputStyle}
                  ${isSlim ? classes.inputStyleSlim : classes.inputStyle}
                  ${noMargin ? classes.noMargin : ''}
                  `}
        id={label}
        type={type}
        name={name}
        defaultValue={defaultValue}
        onChange={onChange}
        placeholder={placeholder}
        label={label}
        onBlur={onBlur}
        value={value}
        endAdornment={endAdornment}
        onClick={onClick}
        multiline={!!multiline}
        rows={rows}
        sx={{ height: !!multiline ? 'auto !important' : '49px', backgroundColor: isError ? 'pink' : 'white' }}
        disabled={!!disabled}
        error={isError}
        inputProps={{ maxLength: maxCharLength }}
      />
      {errors && touched ? (
        <FormHelperText error className={classes.errorHelperText}>
          {' '}
          {errors}{' '}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};
